import * as React from 'react';

import {
  General,
  GeneralDismiss,
  NextAction,
} from '@showbie/utilities/message';
import { translate } from '~l10n/client';

import { SmallButton } from '~shared/components/buttons';
import { IconPlus } from '~shared/components/icons/standard';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';
import { useSocrativeRouter } from '~teacher/context/RouterContext';

import { sendMessageWithMessageOnly } from '../../showbie/messages/sendMessageHelper';

function useHandleAddQuiz() {
  const teacherApplicationContext = useTeacherApplicationContext();
  const router = useSocrativeRouter();

  const handleAddQuiz = (): void => {
    switch (teacherApplicationContext) {
      case TeacherApplicationContext.Socrative: {
        //TODO: ADD ANALYTICS HERE
        router.navigate(`quizzes`, {
          trigger: true,
        });
        return;
      }
      case TeacherApplicationContext.ShowbieAssessments: {
        //TODO: ADD ANALYTICS HERE

        const message: GeneralDismiss = {
          type: General.Dismiss,
          payload: { next_action: NextAction.AddQuiz },
        };
        sendMessageWithMessageOnly(message);
        return;
      }
      default: {
        const _exhaustiveCheck: never = teacherApplicationContext;
        return _exhaustiveCheck;
      }
    }
  };

  return { handleAddQuiz, teacherApplicationContext, router };
}

export function AddQuizButton() {
  const { handleAddQuiz, teacherApplicationContext } = useHandleAddQuiz();

  return (
    <div className="py-4 px-2">
      <SmallButton
        onClick={handleAddQuiz}
        xPadding={0}
        yPadding={0}
        appearance="text"
      >
        <div className="flex items-center gap-4 pr-3">
          <IconPlus />
          {translate('Add Quiz')}
        </div>
      </SmallButton>
    </div>
  );
}
